import React from 'react'
import TemplateInfoEditor from './TemplateInfoEditor'
import TemplateDataEditor from './TemplateDataEditor'

function createInfoEditor( template, props ) {
  return <TemplateInfoEditor template={template} {...props} />
}

function createDataEditor( intentType, props ) {
  return <TemplateDataEditor intentType={intentType} {...props} />
}

exports.createInfoEditor = createInfoEditor
exports.createDataEditor = createDataEditor
